import { GroupRelation, SettingsResponseInterface } from '../../services/responses/settings.response';

class RelationMap extends Map<K, V> {
  public init(groupRelations: SettingsResponseInterface['groupRelations']): void {
    this.clear();
    for (const relationsData of groupRelations) {
      this.set(relationsData.key, {
        relationsData,
        relations: {},
      });
    }
  }

  public setRelationsByGroup(group: string, relations: IRelations = {}): void {
    let hasActiveRelations = false;
    Object.entries(relations).forEach(([relationKey, value]) => {
      if (!hasActiveRelations && value?.values?.length) {
        hasActiveRelations = true;
      }
      if (!value?.values?.length) {
        delete relations[relationKey];
      }
    });
    this.set(group, Object.assign(this.get(group), { relations, hasActiveRelations }));
  }

  public setAllRelations(relations: Record<string, IRelations>): void {
    for (const [key, value] of Object.entries(relations)) {
      this.setRelationsByGroup(key, value);
    }
  }

  public clearRelations(key: string): void {
    this.set(key, Object.assign(this.get(key), { relations: {}, hasActiveRelations: false }));
  }

  public clearAllRelations(): void {
    for (const key of this.keys()) {
      this.set(key, Object.assign(this.get(key), { relations: {}, hasActiveRelations: false }));
    }
  }

  public hasActiveRelations(key: string): boolean {
    return !!this.get(key)?.hasActiveRelations;
  }

  public getRelationsByGroups(groups: string[]): unknown {
    return [...this.entries()].reduce((acc, [key, value]) => {
      if (groups.includes(key)) {
        acc[key] = value.relations;
      }
      return acc;
    }, {});
  }
}

export const relationMap = new RelationMap();

export interface IRelations {
  [key: string]: { values: string[] };
}

type K = string;
interface V {
  relationsData: GroupRelation;
  relations: IRelations;
  hasActiveRelations?: boolean;
}
